<template>
  <div class="setting_balloon setting_balloon_category_add">
    <div class="setting_balloon_content">
      <div class="setting_balloon_content_main">
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ labelProperties.labelItemName }}
            </p>
            <p class="setting_label">
              {{ labelProperties.labelRequired }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <input
              class="setting_form_text"
              type="text"
              v-model="item.itemName"
              :placeholder="labelProperties.placeholderItemName"
            />
          </div>
        </div>
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ labelProperties.labelItemContent }}
            </p>
            <p class="setting_label">
              {{ labelProperties.labelRequired }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <draggable
              :list="item.resourceField"
              draggable=".item"
              :group="{ name: 'item-company', put: checkResourceLength() === 0 }"
              @add="addItemToResourceField()"
            >
              <div
                v-for="(resource, index) in item.resourceField"
                :key="index"
                class="item"
              >
                <div
                  class="setting_form_wrapper"
                  v-if="!resource.itemResourceDeleted"
                >
                  <input
                      class="setting_form_text"
                      type="text"
                      :placeholder="labelProperties.placeholderDropDragItem"
                      v-model="resource.display_name"
                      readonly
                      :class="{'resource-delete-setting': resource.isItemDeletedByMainSystem}"
                  />
                  <div
                    class="setting_form_wrapper_close"
                    @click="deleteResource(index)"
                  >
                    <svg
                      width="12"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <rect fill="#555" width="12" height="12" rx="2" />
                        <g fill="#FFF">
                          <path d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z" />
                          <path d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z" />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                slot="footer"
                class="setting_form_wrapper"
                v-if="checkResourceLength() === 0"
              >
                <input
                  class="setting_form_text"
                  type="text"
                  :placeholder="labelProperties.placeholderDropDragItem"
                  readonly
                />
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div class="setting_balloon_footer">
      <button
        class="setting_btn_outline setting_btn_small"
        @click.prevent="$emit('close')"
      >
        {{ labelProperties.buttonCancel }}
      </button>
      <button class="setting_btn_primary setting_btn_small" @click.prevent="$emit('submit')"
              :class="{'setting_btn_disabled': !item.itemName || checkResourceLength() <= 0}">
        {{ labelProperties.buttonReflect }}
      </button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import labelProperties from "../../../../../properties/job_screen/detail_tab/detail-labels.json";

const ITEM_SETTING_IN_LIST_TAB = 5;
export default {
  name: "DetailItemModal",
  components: {
    draggable,
  },
  props: ["item","companyResourceFields","resourceFields"],
  data() {
    return {
      labelProperties: labelProperties,
    };
  },
  methods: {
    addItemToResourceField() {
      this.item.resourceField.forEach((item, index) => {
        this.item.resourceField[index] = JSON.parse(JSON.stringify(item));
      })
      let item = this.item.resourceField.filter(item => item && !item.itemResourceDeleted);
      let isNullItem = !item || item.length <= 0;
      let isNullJobResourceField = !this.resourceFields || this.resourceFields.length <= 0;
      let isNullCompanyResourceField = !this.companyResourceFields || this.companyResourceFields.length <= 0;
      if(isNullItem || isNullJobResourceField || isNullCompanyResourceField){
        return;
      }
      this.updateStatusItemUsed(this.resourceFields, item, "updateResourceFields");
      this.updateStatusItemUsed(this.companyResourceFields, item, "updateCompanyResourceFields");
    },

    updateStatusItemUsed(resourceFields, item, updateResourceFields) {
      resourceFields.filter(resource => resource.name === item[0].name && resource.display_name === item[0].display_name).forEach(resource => {
        if (!resource.isUsed) {
          resource.isUsed = [];
        }

        resource.isUsed.push(ITEM_SETTING_IN_LIST_TAB);
      });

      this.$emit(updateResourceFields, resourceFields);
    },

    checkResourceLength() {
      return this.item.resourceField.filter(resource => !resource.itemResourceDeleted).length;
    },

    deleteResource(index) {
      let isNullJobResourceField = !this.resourceFields || this.resourceFields.length <= 0;
      let isNullCompanyResourceField = !this.companyResourceFields || this.companyResourceFields.length <= 0;
      if(index < 0 || isNullJobResourceField || isNullCompanyResourceField){
        return;
      }

      let item = this.item.resourceField[index];
      this.removeStatusItemUsed(this.resourceFields, item, "updateResourceFields");
      this.removeStatusItemUsed(this.companyResourceFields, item, "updateCompanyResourceFields");
      this.item.resourceField[index].itemResourceDeleted = true;
      this.item.resourceField = JSON.parse(JSON.stringify(this.item.resourceField));
    },

    removeStatusItemUsed(resourceFields, item, updateResourceFields) {
      resourceFields.filter(resource => resource.name === item.name).forEach(resource => {
        if (!resource.isUsed || resource.isUsed.length <= 0 || !resource.isUsed.includes(ITEM_SETTING_IN_LIST_TAB)) {
          return;
        }

        resource.isUsed.splice(resource.isUsed.indexOf(ITEM_SETTING_IN_LIST_TAB), 1);
      });

      this.$emit(updateResourceFields, resourceFields);
    }
  },
};
</script>
